import { ref, computed, Ref } from 'vue';
import { useLocalStorage } from '@vueuse/core';

export type NavbarPosition = 'horizontal' | 'vertical';

const navbarPosition = useLocalStorage<NavbarPosition>('navbar-position', 'horizontal');

export function useNavbarLayout(isMobile: Ref<boolean> | boolean = false) {
  // En móvil (pantallas verticales), siempre forzamos horizontal
  // En desktop (pantallas horizontales), permitimos vertical según preferencia
  const isVertical = computed(() => {
    const mobileValue = typeof isMobile === 'boolean' ? isMobile : isMobile.value;
    return !mobileValue && navbarPosition.value === 'vertical';
  });
  const isHorizontal = computed(() => {
    const mobileValue = typeof isMobile === 'boolean' ? isMobile : isMobile.value;
    return mobileValue || navbarPosition.value === 'horizontal';
  });

  const setNavbarPosition = (position: NavbarPosition) => {
    const mobileValue = typeof isMobile === 'boolean' ? isMobile : isMobile.value;
    if (!mobileValue) {
      navbarPosition.value = position;
    }
  };

  const toggleNavbarPosition = () => {
    const mobileValue = typeof isMobile === 'boolean' ? isMobile : isMobile.value;
    if (!mobileValue) {
      navbarPosition.value = navbarPosition.value === 'horizontal' ? 'vertical' : 'horizontal';
    }
  };

  return {
    navbarPosition: computed(() => navbarPosition.value),
    isVertical,
    isHorizontal,
    setNavbarPosition,
    toggleNavbarPosition
  };
}
